export type PipeInventoryPrefillInput = {
  projectId?: string | number | null;
  projectNumber?: string | null;
  pipeNo?: string | null;
  pipePipeId?: string | null;
  pipeSizesData: Array<Record<string, unknown>>;
  /** Optional Fitter JSON — never used for OD/wall measurements. */
  fitterPipeData?: unknown;
};

export type PipeInventoryPrefillResult =
  | {
      status: 'ok';
      pipeNo: string;
      pipePipeId: string;
      pipeOuterDiameterInches: number;
      pipeWallThicknessInches: number;
    }
  | { status: 'skip'; reason: 'no_project' | 'no_pipe_no' }
  | {
      status: 'missing_setup';
      reason: 'size_not_found';
      pipeOuterDiameterInches: null;
      pipeWallThicknessInches: null;
    };

/**
 * Prefill inventory OD/wall from project pipe setup (inches).
 * Fitter pipeData measurements are never used for dimensions.
 */
function hasProject(input: PipeInventoryPrefillInput): boolean {
  if (input.projectId != null && String(input.projectId).trim() !== '') return true;
  if (input.projectNumber != null && String(input.projectNumber).trim() !== '') return true;
  return false;
}

export function resolvePipeInventoryPrefill(
  input: PipeInventoryPrefillInput
): PipeInventoryPrefillResult {
  if (!hasProject(input)) {
    return { status: 'skip', reason: 'no_project' };
  }

  const pipeNo = String(input.pipeNo ?? '').trim();
  if (!pipeNo) {
    return { status: 'skip', reason: 'no_pipe_no' };
  }

  const pipePipeId = String(input.pipePipeId ?? '').trim();
  const setup = input.pipeSizesData.find((p) => String(p.pipeId) === pipePipeId);
  if (!setup) {
    return {
      status: 'missing_setup',
      reason: 'size_not_found',
      pipeOuterDiameterInches: null,
      pipeWallThicknessInches: null,
    };
  }

  // extractPipeSizesFromPipeDetails uses `size`; some callers use `pipeSize`
  const od = Number(setup.pipeSize ?? setup.size);
  const wall = Number(setup.wallThickness);

  return {
    status: 'ok',
    pipeNo,
    pipePipeId,
    pipeOuterDiameterInches: od,
    pipeWallThicknessInches: wall,
  };
}
